<section class="carousel-wrapper" [ngStyle]="getCarouselWrapperStyle()">
  <ul class="carousel-inner" #carousel>
    @for (item of items; track item) {
      <li class="carousel-item">
        <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
      </li>
    }
  </ul>
</section>
@if (showControls) {
  <div>
    @if (haveNext()) {
      <button data-testid="carousel-next" class="next-button carousel-button"  (click)="next()" [attr.aria-label]="'next'" ></button>
    }
    @if (havePrev()) {
      <button data-testid="carousel-previous" class="prev-button carousel-button" (click)="prev()" [attr.aria-label]="'previous'" ></button>
    }
  </div>
}
